import React, { ReactElement } from 'react';
import { Immutable } from '@wds/utils';
import { Box } from '@wds/box';
import { IconBell } from '@wds/icons';
import { NavButton } from '../nav-button';
import useStyles from './useStyles';

export type NotificationsIconProps = Immutable<{
  showNotifications: boolean;
}> & {
  toggleNotifications(): void;
};

const NotificationsIcon = ({
  showNotifications,
  toggleNotifications,
}: NotificationsIconProps): ReactElement => {
  const { notificationsBadge } = useStyles();

  return (
    <NavButton
      onClick={toggleNotifications}
      label="See my notifications"
      active={showNotifications}
    >
      <Box>
        <div className={notificationsBadge}>2</div>
        <IconBell title="Notifications icon" size="lg" />
      </Box>
    </NavButton>
  );
};

export default NotificationsIcon;
export { NotificationsIcon };
